export default __webpack_public_path__ + "static/media/player-image.03961105.svg";